var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--sub"
  }, [_c('sub-visual', {
    class: _vm.typeClass,
    attrs: {
      "visual": _vm.typeName
    }
  }), _c('div', {
    staticClass: "contents"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm.isAuthorized ? [_c('div', {
    staticClass: "board-container"
  }, [_c('div', {
    staticClass: "mb-60 mb-md-40"
  }, [_c('view-request', {
    attrs: {
      "request": _vm.request,
      "isLong": _vm.isLong
    }
  })], 1), _c('div', [_c('view-responses', {
    model: {
      value: _vm.request,
      callback: function callback($$v) {
        _vm.request = $$v;
      },
      expression: "request"
    }
  })], 1), _c('div', {
    staticClass: "board-buttons board-buttons--right-center mt-30 mt-md-20"
  }, [_c('div', {
    staticClass: "left"
  }), _c('div', {
    staticClass: "right"
  }, [_vm.isRequester ? _c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "red"
    },
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("삭제")]) : _vm._e(), _vm.isRequester ? _c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "gray-9"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push("".concat(_vm.$route.path, "/modify"));
      }
    }
  }, [_vm._v("수정")]) : _vm._e(), _vm.isCounselor ? _c('counsel-report', {
    attrs: {
      "request": _vm.request
    }
  }) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "gray-9"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push("/counsel/".concat(_vm.type, "/"));
      }
    }
  }, [_vm._v("목록")])], 1)]), _vm.request.isDone ? _c('div', {
    staticClass: "card card--primary text-center mt-70 mt-md-30 py-5 py-md-7"
  }, [_c('p', {
    staticClass: "text-16 text-md-14 color-gray-2 font-weight-bold"
  }, [_vm._v("자문요청이 종료되었습니다.")])]) : _vm.isRequester && !_vm.isLong ? _c('div', {
    staticClass: "card card--primary text-center mt-70 mt-md-30 py-5 py-md-7"
  }, [_c('p', {
    staticClass: "text-16 text-md-14 color-gray-2 font-weight-bold mb-15 mb-md-10"
  }, [_vm._v("자문단의 답변이 충분히 도움이 되었다면 자문종료 처리를 해주시기 바랍니다.")]), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.complete
    }
  }, [_vm._v("자문요청 종료")])], 1) : _vm._e()])] : [_c('div', {
    staticClass: "card card--primary"
  }, [_c('p', {
    staticClass: "text-18 text-md-16 font-weight-medium"
  }, [_vm._v("권한이 없습니다.")])])]], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }